import { Typography } from 'antd';
import { Avatar } from 'components/common';
import OmiChanelChatSourceIcon from 'components/omni-channel-chat/OmiChanelChatSourceIcon';
import dayjs from 'dayjs';
import React from 'react';
import { ChatSessionDto } from 'types';

type Props = {
  item: ChatSessionDto;
  onClick?: () => void;
};

const OmniChannelLeadChatHistoriesSessionItem: React.FC<Props> = ({ item, onClick }) => {
  return (
    <div className='flex h-18 w-full cursor-pointer gap-3 px-5 py-3 hover:bg-backgroundColor4' onClick={onClick}>
      <div className='relative h-12 w-12'>
        <Avatar key={item.chatSessionId} size={48} src={item.chat?.customerAvatar} name={item.chat?.customerName} />
        <div className='absolute -bottom-0.5 -right-0.5 flex items-center justify-center'>
          <OmiChanelChatSourceIcon size={20} source={item.chat?.source} />
        </div>
      </div>
      <div className='flex flex-1 justify-between'>
        <div className='flex flex-1 flex-col gap-1'>
          <div className='flex items-center justify-between'>
            <Typography.Text ellipsis className='font-semibold'>
              {item.chat?.customerName}
            </Typography.Text>
            <Typography.Text className='text-xs text-colorTextPlaceholder'>
              {dayjs(item?.createdAt).format('DD/MM/YYYY')}
            </Typography.Text>
          </div>
          <div className='flex items-center justify-between'>
            <div className='flex w-full items-center gap-2'>
              <Avatar
                key={item.assigner?.userId}
                size={18}
                src={item?.assigner?.avatar}
                name={item?.assigner?.fullName}
              />
              <Typography.Text className='text-xs text-colorTextPlaceholder'>
                {item?.assigner?.fullName}
              </Typography.Text>
              <Typography.Text className='text-xs text-colorTextPlaceholder'>•</Typography.Text>
              <Typography.Text className='text-xs text-colorTextPlaceholder'>Ext. {item.extensionId}</Typography.Text>
            </div>
            <div className='w-fit shrink-0'>
              <Typography.Text className='text-xs'>
                {dayjs(item?.createdAt).format('HH:mm')}
                {item.completedAt ? ` - ${dayjs(item.completedAt).format('HH:mm')}` : ''}
              </Typography.Text>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default OmniChannelLeadChatHistoriesSessionItem;
